(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_password-access"] && !Shopify.designMode) return;
  try {
    import('@theme/dialog').then(({ DialogComponent }) => {
  class PasswordAccess extends DialogComponent {
    connectedCallback() {
      super.connectedCallback();
      if (this.refs.dialog.hasAttribute('data-password-error')) {
        this.refs.dialog.close();
        this.showDialog();
      }
    }
  }
  if (!customElements.get('cs-password-access')) customElements.define('cs-password-access', PasswordAccess);
  });
  } catch(e) { console.error(e); }
})();

})();
